export type ProcessingButtonProps = {
    title: string;
    subtitle?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
    icon: React.ReactChild;
    active?: boolean;
    disabled?: boolean;
    trackName: string;
    trackData?: object;
};
